module.exports = __webpack_public_path__ + "img/icon-1.3409e621.svg";